import script from "./AboutSelf.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutSelf.vue?vue&type=script&setup=true&lang=js"

import "./AboutSelf.vue?vue&type=style&index=0&id=ac9365ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac9365ac"]])

export default __exports__